import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";
import {
  fontWeightSemiBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";

export const CreateClientSemiHeaderWrapper = styled.div`
  .header-label {
    line-height: 20px;
    color: ${COLORS.cirrus_black};
  }
  .header-label-value {
    line-height: 20px;
    color: ${COLORS.cirrus_black};
    ${responsive.MOBILE`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
    `}
  }
  .semi-header-container {
    padding: 24px 16px;
    display: flex;
    flex-direction: row;

    ${responsive.MOBILE`
    padding: 16px 8px;
    gap: 24px;
     flex-direction: column;
      align-items: flex-start;
    `}
  }
  .header-parent-client-container {
    display: flex;
    flex-direction: column;
  }
  .header-tag-parent-container {
    justify-content: flex-end;
    ${responsive.MOBILE`
      margin-top: 24px;
      justify-content: flex-start;
    `}
  }
  .header-parent-client-button-container {
    display: flex;
    align-items: baseline;
    margin-top: 8px;
  }
  .header-tag-parent {
    ${h3Regular}
    ${fontWeightSemiBold}
    cursor: pointer;
    text-decoration: underline;
    height: auto;
    width: auto;
    align-self: flex-end;
    &:disabled {
      text-decoration: none;
      color: ${COLORS.cirrus_black5};
    }
  }

  .MuiAccordionSummary-root {
    padding: 0px;
  }

  .tagIcon {
    margin-right: 5px;
    .disabled {
      opacity: 0.5;
    }
  }
  .header-tag-parent-error-icon {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
  }
`;
